import { ContentItem } from 'kentico-cloud-delivery';

export class Textblock extends ContentItem {

}